<script lang="ts">
  import { onMount, onDestroy } from 'svelte';
  import { Editor, type Content } from '@tiptap/core';
  import { getTipTapProps } from '$lib/utils/tiptap';

  export let content: Content;

  let element: HTMLElement;
  let editor: Editor;

  onMount(() => {
    editor = new Editor({
      element,
      editable: false,
      content,
      ...getTipTapProps(),
    });
  });

  onDestroy(() => {
    if (editor) {
      editor.destroy();
    }
  });

  // Update the editor when the content prop changes
  $: editor?.commands.setContent(content);
</script>

<div class={$$props.class} bind:this={element} />
